import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ImageOff } from "lucide-react";

// Popup con foto grande, codice e descrizione del componente (dal listino Torri)
export function ComponentInfo({ c, onClose }) {
  return (
    <Dialog open={!!c} onOpenChange={(o) => !o && onClose()}>
      {c && (
        <DialogContent className="max-w-lg border-neutral-800 bg-neutral-950 text-neutral-100" data-testid="component-info-dialog">
          <DialogHeader>
            <DialogTitle className="font-mono text-base" data-testid="component-info-code">{c.codice || c.modello || c.tipo}</DialogTitle>
            <DialogDescription className="text-xs uppercase tracking-wider text-neutral-500">{c.tipo}{c.quantita ? ` × ${c.quantita}` : ""}{c.modello && c.codice ? ` · ${c.modello}` : ""}</DialogDescription>
          </DialogHeader>
          <div className="flex h-56 items-center justify-center overflow-hidden rounded-xl bg-white" data-testid="component-info-foto">
            {c.foto ? <img src={encodeURI(decodeURI(c.foto))} alt={c.codice || c.tipo} className="h-full w-full object-contain p-3" /> : <ImageOff className="h-8 w-8 text-neutral-400" />}
          </div>
          <p className="whitespace-pre-line text-sm leading-relaxed text-neutral-300" data-testid="component-info-descrizione">{c.descrizione || "Descrizione non disponibile nel listino Torri."}</p>
          {c.descrizione_sito && <div className="rounded-xl border border-neutral-800 bg-neutral-900/60 p-3" data-testid="component-info-sito">
            <p className="mb-1 text-[10px] font-bold uppercase tracking-widest text-[#C17F59]">Dal sito torri.solar</p>
            <p className="text-xs leading-relaxed text-neutral-300">{c.descrizione_sito}</p>
            {c.scheda_sito_url && <a href={c.scheda_sito_url} target="_blank" rel="noreferrer" className="mt-2 inline-block text-xs font-bold text-[#C17F59] hover:underline" data-testid="component-info-link">Apri la scheda sul sito →</a>}
          </div>}
          {c.ordine && <p className="text-[11px] text-neutral-500">Dall'ordine Torri {c.ordine}</p>}
        </DialogContent>
      )}
    </Dialog>
  );
}
